import { Link } from "react-router-dom";
import { BadgeCheck, MapPin, Eye, Store, Heart } from "lucide-react";
import { mediaSrc } from "@/lib/api";

export default function ShopCard({ shop, isFav = false, onFavorite = null }) {
  const initial = shop.name?.[0]?.toUpperCase() || "?";

  const handleFav = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onFavorite?.(shop.id);
  };

  return (
    <Link
      to={`/boutique/${shop.id}`}
      data-testid={`shop-card-${shop.id}`}
      className="block rounded-xl overflow-hidden bg-white border border-[#E8E6E1] hover:shadow-md hover:border-[#E65100] transition shrink-0 w-[6.75rem] sm:w-32 relative"
    >
      {/* Cover + profile layered on top */}
      <div className="relative">
        <div className="h-14 sm:h-16 bg-gradient-to-br from-[#FFE4CC] via-[#FFF3E0] to-[#FCFCF9] overflow-hidden">
          {shop.cover_image ? (
            <img src={mediaSrc(shop.cover_image)} alt="" className="h-full w-full object-cover" />
          ) : (
            <div className="absolute inset-0 flex items-center justify-center">
              <Store className="h-5 w-5 text-[#E65100]/30" />
            </div>
          )}
        </div>

        {onFavorite && (
          <button
            type="button"
            onClick={handleFav}
            data-testid={`shop-fav-btn-${shop.id}`}
            aria-label={isFav ? "Retirer des favoris" : "Ajouter aux favoris"}
            className="absolute top-1 right-1 inline-flex items-center justify-center h-6 w-6 rounded-full bg-white/95 shadow-sm backdrop-blur-sm hover:scale-110 transition"
          >
            <Heart className={`h-3.5 w-3.5 ${isFav ? "fill-[#E65100] text-[#E65100]" : "text-[#1A1918]"}`} />
          </button>
        )}

        {/* Profile image — centered, overlapping cover. Verified badge sits on the profile image. */}
        <div className="absolute left-1/2 -translate-x-1/2 -bottom-5 w-11 h-11 z-10">
          <div className="w-full h-full rounded-xl border-2 border-white dark:border-[#1A1918] bg-[#F3F1EC] overflow-hidden shadow-md flex items-center justify-center">
            {shop.profile_image ? (
              <img src={mediaSrc(shop.profile_image)} alt={shop.name} className="h-full w-full object-cover object-center" />
            ) : (
              <span className="text-[#E65100] font-[Manrope] font-extrabold text-base">{initial}</span>
            )}
          </div>
          {shop.verified && (
            <div className="absolute -bottom-0.5 -right-0.5 inline-flex items-center justify-center h-4 w-4 rounded-full bg-white text-[#0A7D3A] border border-white shadow-sm" title="Boutique vérifiée">
              <BadgeCheck className="h-3.5 w-3.5" />
            </div>
          )}
        </div>
      </div>

      <div className="px-2 pt-6 pb-2 text-center">
        <div className="font-bold text-[12px] text-[#1A1918] truncate leading-tight">{shop.name}</div>

        {shop.city && (
          <div className="mt-0.5 flex items-center justify-center gap-0.5 text-[10px] text-[#73706B] truncate">
            <MapPin className="h-2.5 w-2.5 shrink-0" />
            <span className="truncate">{shop.city}</span>
          </div>
        )}

        <div className="mt-1 pt-1 border-t border-[#E8E6E1] flex items-center justify-between text-[10px] text-[#73706B]">
          <span className="font-semibold text-[#1A1918]">{shop.product_count || 0} prod.</span>
          <span className="inline-flex items-center gap-0.5">
            <Eye className="h-2.5 w-2.5" /> {shop.views_3m || 0}
          </span>
        </div>
      </div>
    </Link>
  );
}
